import { render, staticRenderFns } from "./PortfolioUploadSection.vue?vue&type=template&id=2afa4026&scoped=true&"
import script from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"
export * from "./PortfolioUploadSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2afa4026",
  null
  
)

export default component.exports